import React, { Component } from 'react';
import firebase from './firebase.js';

import HomePanel from './components/home-panel.js';
import SetPanel from './components/set-panel.js';
import TallyPanel from './components/tally-panel.js';
import LoginPanel from './components/login-panel.js';
import Modal from './modal.js';

export default class Tally extends Component {
	constructor() {
		super();

		this.state = {
			selected: { set: null, tally: null, modal: null },
			modal: null,
			user: null,
			sets: null
		};

		this.handleSelectPanel = this.handleSelectPanel.bind(this);
		this.handleSelectModal = this.handleSelectModal.bind(this);

		this.handleEditSet = this.handleEditSet.bind(this);
		this.handleEditTally = this.handleEditTally.bind(this);
		this.handleMoveTally = this.handleMoveTally.bind(this);
		this.handleEditMark = this.handleEditMark.bind(this);

		this.handleLogin = this.handleLogin.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
	}

	handleSelectPanel(panel, payload) {
		if (panel === 'HOME') {
			document.getElementById('panel-home').checked = true;
			this.setState(state => {
				state.selected.set = null;
				state.selected.tally = null;
				return state;
			});
		}

		if (panel === 'SET') {
			document.getElementById('panel-set').checked = true;
			this.setState(state => {
				state.selected.set = payload.setId;
				state.selected.tally = null;
				return state;
			});
		}
		
		if (panel === 'TALLY') {
			document.getElementById('panel-tally').checked = true;
			this.setState(state => {
				state.selected.tally = payload.tallyId;
				return state;
			});
		}
	}

	handleSelectModal(modal, payload) {
		document.getElementById('modal-toggle').checked = true;

		let setId = this.state.selected.set;
		let tallyId = this.state.selected.tally;

		if (modal === 'ADD-SET') setId = null;
		if (modal === 'ADD-SET' || modal === 'ADD-TALLY') tallyId = null;

		this.setState(state => {
			state.selected.set = setId;
			state.selected.tally = tallyId;
			state.selected.modal = modal;
			state.modal = payload || null;
			return state;
		});
	}

	handleEditSet(action, payload) {
		document.getElementById('modal-toggle').checked = false;
		const setsRef = firebase.database().ref(`${this.state.user.uid}/sets`);

		if (action === 'NEW') setsRef.push({ name: payload.name });
		if (action === 'EDIT') setsRef.child(payload.setId).update({ name: payload.name });
		if (action === 'DELETE') {
			setsRef.child(payload.setId).remove();
			this.handleSelectPanel('HOME');
		}
	}

	handleEditTally(action, payload) {
		document.getElementById('modal-toggle').checked = false;
		const talliesRef = firebase.database().ref(`${this.state.user.uid}/sets/${payload.setId}/tallies`);

		if (action === 'NEW') talliesRef.push({ name: payload.name });
		if (action === 'EDIT') talliesRef.child(payload.tallyId).update({ name: payload.name });
		if (action === 'DELETE') {
			talliesRef.child(payload.tallyId).remove();
			this.handleSelectPanel('SET', { setId: payload.setId });
		}
	}

	handleMoveTally(action, payload) {
		document.getElementById('modal-toggle').checked = false;
		const tallyRef = firebase.database().ref(`${this.state.user.uid}/sets/${payload.fromSetId}/tallies/${payload.tallyId}`);
		const talliesRef = firebase.database().ref(`${this.state.user.uid}/sets/${payload.toSetId}/tallies`);
		
		tallyRef.once('value', snapshot => {
			talliesRef.push(snapshot.val());
			tallyRef.remove();
			this.handleSelectPanel('SET', { setId: payload.toSetId });
		});
	}

	handleEditMark(action, payload) {
		document.getElementById('modal-toggle').checked = false;
		const marksRef = firebase.database().ref(`${this.state.user.uid}/sets/${payload.setId}/tallies/${payload.tallyId}/marks`);

		if (action === 'NEW') marksRef.push({ datetime: payload.datetime, comment: payload.comment });
		if (action === 'EDIT') marksRef.child(payload.markId).update({ datetime: payload.datetime, comment: payload.comment });
		if (action === 'DELETE') marksRef.child(payload.markId).remove();
	}

	handleLogin() {
		const provider = new firebase.auth.GoogleAuthProvider();
		firebase.auth().signInWithPopup(provider).then(result => {
			//
		}).catch(error => {
			alert(error.message);
			console.log(error);
		});
	}

	handleLogout() {
		firebase.auth().signOut().then(() => {
			//
		}).catch(error => {
			alert(error.message);
			console.log(error);
		});
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				const dataRef = firebase.database().ref(`${user.uid}/sets`);
				dataRef.on('value', snapshot => {
					let sets = snapshot.val();
					
					if (sets) {
						sets = Object.keys(snapshot.val())
							.reduce((sets, setId) => [...sets, { ...snapshot.val()[setId], id: setId }], [])
							.sort((a, b) => a.name.localeCompare(b.name));
						
						sets.forEach((set) => {
							if (set.tallies) {
								set.tallies = Object.keys(set.tallies)
									.reduce((tallies, tallyId) => [...tallies, { ...set.tallies[tallyId], id: tallyId }], [])
									.sort((a, b) => a.name.localeCompare(b.name))

								set.tallies.forEach((tally) => {
									if (tally.marks) {
										tally.marks = Object.keys(tally.marks)
											.reduce((marks, markId) => [...marks, { ...tally.marks[markId], id: markId }], [])
											.sort((a, b) => b.datetime.localeCompare(a.datetime));
									}
								});
							}
						});
					}

					this.setState(state => {
						state.sets = sets;
						return state;
					});
				});

				this.setState(state => {
					state.user = user;
					return state;
				});
			} else {
				this.setState(state => {
					state.user = null;
					state.sets = null;
					return state;
				});
			}
		}).bind(this);
	}

	render() {
		return (
			<div className="tl-viewport">
				<input id="modal-toggle" type="checkbox" className="f-hidden" />

				<input id="panel-home" type="radio" className="f-hidden" name="panel-select" defaultChecked />
				<input id="panel-set" type="radio" className="f-hidden" name="panel-select" />
				<input id="panel-tally" type="radio" className="f-hidden" name="panel-select" />

				<div className="tl-page">
					<div className="tl-panel alt-home">
						<div className="tl-panel-frame">	
							{this.state.user ? (
								<HomePanel
									sets={this.state.sets}
									userEmail={this.state.user.email}
									handleSelectPanel={this.handleSelectPanel}
									handleSelectModal={this.handleSelectModal}
									handleLogout={this.handleLogout}
								/>
							) : (
								<LoginPanel
									handleLogin={this.handleLogin}
								/>
							)}
						</div>
					</div>

					<div className="tl-panel alt-set">
						<label htmlFor="panel-home" className="tl-panel-overlay"></label>
						<div className="tl-panel-frame">
							{this.state.selected.set && (
								<SetPanel
									set={this.state.sets.find((set) => this.state.selected.set === set.id)}
									selectedSet={this.state.selected.set}
									handleSelectPanel={this.handleSelectPanel}
									handleSelectModal={this.handleSelectModal}
									handleEditMark={this.handleEditMark}
								/>
							)}
						</div>
					</div>

					<div className="tl-panel alt-tally">
						<label htmlFor="panel-set" className="tl-panel-overlay"></label>
						<div className="tl-panel-frame">
							{this.state.selected.tally && (
								<TallyPanel
									tally={this.state
										.sets.find((set) => this.state.selected.set === set.id)
										.tallies.find((tally) => this.state.selected.tally === tally.id)}
									selectedSet={this.state.selected.set}
									selectedTally={this.state.selected.tally}
									handleSelectModal={this.handleSelectModal}
								/>
							)}
						</div>
					</div>
				</div>

				<div className="tl-modal">
					<label htmlFor="modal-toggle" className="tl-modal-overlay"></label>
					<div className="tl-modal-frame">
						<Modal
							modal={this.state.modal}
							sets={this.state.sets}
							selectedSet={this.state.selected.set}
							selectedTally={this.state.selected.tally}
							selectedModal={this.state.selected.modal}
							handleEditSet={this.handleEditSet}
							handleEditTally={this.handleEditTally}
							handleMoveTally={this.handleMoveTally}
							handleEditMark={this.handleEditMark}
						/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/tally.js